import { render, staticRenderFns } from "./InsightPanel.vue?vue&type=template&id=4467c856&scoped=true"
import script from "./InsightPanel.vue?vue&type=script&lang=js"
export * from "./InsightPanel.vue?vue&type=script&lang=js"
import style0 from "./InsightPanel.vue?vue&type=style&index=0&id=4467c856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467c856",
  null
  
)

export default component.exports